export const SET_CARD_STORE = "SET_CARD_STORE";
export const SET_CARD_RESET = "SET_CARD_RESET";
export const SET_LIMIT_4_NUMBER_DIGIT = "SET_LIMIT_4_NUMBER_DIGIT";

// Lấy DS thẻ
export const FETCH_CARD_LIST_REQUEST = "FETCH_CARD_LIST_REQUEST";
export const FETCH_CARD_LIST_SUCCESS = "FETCH_CARD_LIST_SUCCESS";
export const FETCH_CARD_LIST_FAILURE = "FETCH_CARD_LIST_FAILURE";

// Lấy chi tiết thẻ
export const FETCH_CARD_DETAIL_REQUEST = "FETCH_CARD_DETAIL_REQUEST";
export const FETCH_CARD_DETAIL_SUCCESS = "FETCH_CARD_DETAIL_SUCCESS";
export const FETCH_CARD_DETAIL_FAILURE = "FETCH_CARD_DETAIL_FAILURE";

// Kích hoạt thẻ
export const FETCH_CARD_ACTIVATE_REQUEST = "FETCH_CARD_ACTIVATE_REQUEST";
export const FETCH_CARD_ACTIVATE_SUCCESS = "FETCH_CARD_ACTIVATE_SUCCESS";
export const FETCH_CARD_ACTIVATE_FAILURE = "FETCH_CARD_ACTIVATE_FAILURE";

// Khoá/ Mở khoá thẻ
export const FETCH_CARD_LOCK_UNLOCK_REQUEST = "FETCH_CARD_LOCK_UNLOCK_REQUEST";
export const FETCH_CARD_LOCK_UNLOCK_SUCCESS = "FETCH_CARD_LOCK_UNLOCK_SUCCESS";
export const FETCH_CARD_LOCK_UNLOCK_FAILURE = "FETCH_CARD_LOCK_UNLOCK_FAILURE";

// Khoá/ Mở khoá giao dịch trực tuyến
export const FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST = "FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST";
export const FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS = "FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS";
export const FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE = "FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE";

// Xem full số thẻ
export const FETCH_CARD_FULL_NUMBER_REQUEST = "FETCH_CARD_FULL_NUMBER_REQUEST";
export const FETCH_CARD_FULL_NUMBER_SUCCESS = "FETCH_CARD_FULL_NUMBER_SUCCESS";
export const FETCH_CARD_FULL_NUMBER_FAILURE = "FETCH_CARD_FULL_NUMBER_FAILURE";

// Lịch sử giao dịch
export const FETCH_CARD_HISTORY_REQUEST = "FETCH_CARD_HISTORY_REQUEST";
export const FETCH_CARD_HISTORY_SUCCESS = "FETCH_CARD_HISTORY_SUCCESS";
export const FETCH_CARD_HISTORY_FAILURE = "FETCH_CARD_HISTORY_FAILURE";

// Sao kê thẻ tín dụng
export const FETCH_CARD_STATEMENT_REQUEST = "FETCH_CARD_STATEMENT_REQUEST";
export const FETCH_CARD_STATEMENT_SUCCESS = "FETCH_CARD_STATEMENT_SUCCESS";
export const FETCH_CARD_STATEMENT_FAILURE = "FETCH_CARD_STATEMENT_FAILURE";

// Đăng ký thẻ vật lý
export const FETCH_CARD_PHYSICAL_REGISTER_REQUEST = "FETCH_CARD_PHYSICAL_REGISTER_REQUEST";
export const FETCH_CARD_PHYSICAL_REGISTER_SUCCESS = "FETCH_CARD_PHYSICAL_REGISTER_SUCCESS";
export const FETCH_CARD_PHYSICAL_REGISTER_FAILURE = "FETCH_CARD_PHYSICAL_REGISTER_FAILURE";

// Xác thực thẻ
export const FETCH_CARD_AUTHORIZATION_KEY_REQUEST = "FETCH_CARD_AUTHORIZATION_KEY_REQUEST";
export const FETCH_CARD_AUTHORIZATION_KEY_SUCCESS = "FETCH_CARD_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_CARD_AUTHORIZATION_KEY_FAILURE = "FETCH_CARD_AUTHORIZATION_KEY_FAILURE";
